import React from 'react';
import { ToastContainer } from 'react-bootstrap';
import { useAppSelector, useAppDispatch } from '../../app/hooks';
import Toast from 'react-bootstrap/Toast';
import { hide } from './toastSlice';

function InnerInfoToast() {
  const dispatch = useAppDispatch();
  const message = useAppSelector(state => state.toast.message);

  return (
    <ToastContainer position={'middle-center'}>
      <Toast show={true} onClose={() => dispatch(hide())} autohide delay={2000}>
        <Toast.Body className="py-4 d-flex">
          <strong className="text-white mx-auto">{message}</strong>
          <button type="button" className="btn-close" aria-label="Close" onClick={() => dispatch(hide())}></button>
        </Toast.Body>
      </Toast>
    </ToastContainer>
  );
}

function InfoToast() {
  const visible = useAppSelector(state => state.toast.visible);  
  return visible ? <InnerInfoToast/> : null;
}

export default InfoToast;